import { CommonHeader as CommonCommonHeader } from '@monorepo/common';
import type { Session } from 'next-auth';
import type { useSession } from 'next-auth/react';

// biome-ignore lint/style/useNodejsImportProtocol: <explanation>
import type { UrlObject } from 'url';
import { VARIANT } from '@/constants';
import type { Route } from 'next';

type CommonHeaderProps<T extends string> = {
  initialSessionData?: ReturnType<typeof useSession>['data'];
  isOptionNotEntered?: boolean;
  hasPendingEntry?: boolean;
  hasAlertEcItem?: boolean;
  siteName: string;
  logoHref?: Route<T> | UrlObject;
  callbackUrl?: string;
};

function CommonHeader<T extends string>({
  initialSessionData,
  isOptionNotEntered = false,
  hasPendingEntry = false,
  hasAlertEcItem = false,
  siteName,
  logoHref = '/',
  callbackUrl = '/',
}: CommonHeaderProps<T>) {
  return (
    <CommonCommonHeader
      initialSessionData={initialSessionData}
      isOptionNotEntered={isOptionNotEntered}
      hasPendingEntry={hasPendingEntry}
      hasAlertEcItem={hasAlertEcItem}
      siteName={siteName}
      logoHref={logoHref}
      callbackUrl={callbackUrl}
      variant={VARIANT}
    />
  );
}

export default CommonHeader;
